import { Stack } from "@mui/material";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CircuitEditInfo } from "./circuitEditInfo";
import { User } from "../user/objects/user";

interface CircuitCreateStepperPackageInformationProps {
    userTO?: { userTO: User | null, setUserTO: React.Dispatch<React.SetStateAction<User | null>> }
}

export const CircuitCreateStepperPackageInformation: FC<CircuitCreateStepperPackageInformationProps> = ({ userTO }) => {
    const { t } = useTranslation();

    return (
        <Stack direction={'column'} justifyContent={'center'} sx={{ maxWidth: 'md', width: '100%', gap: 2 }}>
            <CircuitEditInfo
                circuit={null}
                onClose={() => { return; }}
                onSave={() => { return; }}
                userTO={userTO}
            >
                {() => <></>}
                {/* {
                    () => (
                        <>
                            <Accordion square expanded>
                                <AccordionSummary className={'ft-user-title'}>
                                    <Typography>{t('shared.circuit-info-contract')}</Typography>
                                </AccordionSummary>
                                <AccordionDetails className={'ft-user-subContainer'}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <CircuitProvider />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <CircuitContract />
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                            {actions}
                        </>
                    )
                } */}
            </CircuitEditInfo>
        </Stack>
    );
};